export function hexStringToNumber(hexColor: string): number {
  const colorValue = hexColor.slice(1);
  return parseInt(colorValue, 16);
}
